// Always-on release banner, bottom-right — mirrors the wiki/recruiting apps'
// BuildInfo (their Next.js NEXT_PUBLIC_* → our Vite VITE_*). Shows the git sha +
// release time so any screen says exactly which build it is. CI injects
// VITE_GIT_SHA + VITE_BUILD_TIME at `vite build` (see .github/workflows/deploy.yml);
// locally they're unset, so it reads "dev".
export function BuildInfo() {
  const sha = (import.meta.env.VITE_GIT_SHA as string | undefined) ?? 'dev';
  const buildTime = import.meta.env.VITE_BUILD_TIME as string | undefined;
  const formatted = buildTime
    ? (() => {
        const d = new Date(buildTime);
        const pad = (n: number) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
      })()
    : null;

  return (
    <div
      className="text-muted-foreground/70 pointer-events-none fixed right-4 bottom-4 z-50 font-mono text-[10px] select-none"
      data-testid="build-info"
    >
      {sha}
      {formatted ? ` · ${formatted}` : ''}
    </div>
  );
}
